/* eslint-disable max-len */
export const environment = {
    production: false,
    isLocal: false,

    url: 'https://apiqa.digitaltouch-point.com/api',
    api_static_files: 'https://staticqa.digitaltouch-point.com',

    ENTRA_ID_CLIENT_ID: '0844ba1d-607e-4bdb-825c-19c7a1b68fee',
    ENTRA_ID_REDIRECT: 'https://perksadmin-qa.nextpass.io',
    B2C_CNAME: 'rucnonprod.b2clogin.com',
    B2C_TENANT: 'rucnonprod.onmicrosoft.com',
    POLICY: 'B2C_1A_MULTIPLESOCIALSUSI_DEV',
    APPLICATION_ID: 'f84c1542-ca54-47f4-8d65-95ba4de8f1c2',
    APPLICATION_URL: 'http%3A%2F%2Flocalhost%3A4200%2Fdashboard',
    APPLICATION_SCOPE:
        'openid%20offline_access%20https%3A%2F%2Frucnonprod.onmicrosoft.com%2Fapim-product-oregoruc-dev%2Faccess.write%20https%3A%2F%2Frucnonprod.onmicrosoft.com%2Fapim-product-oregoruc-dev%2Faccess.read',

    mockBaseUrl: 'http://localhost:3000/api',
    useMocks: false,
    appBaseUrl: 'https://perks-qa.nextpass.io',
    impersonationAppBaseUrls: {
        PRISM_I66: 'https://app-qa.ride66expressrewards.com',
        PRISM_I77: 'https://app-qa.i77expressrewards.com',
        NEXTPASS: 'https://appqa.nextpass.io',
        OREGO_RUC: 'https://miles-appqa.nextpass.io',
        NEXTPASS_FLEETS: 'https://business-appqa.nextpass.io',
    } as Record<string, string>,
};
